import web from "../web";

class TypescontratsService {
    index(token){
        return web.get("/api/typescontrats", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/typescontrats", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/typescontrats/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/typescontrats/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/ptyescontrats/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new TypescontratsService()